import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Shared CSV export helper for the Reports module (Overview table + category
// drill-down) -- 2026-08-15. Uses the app's existing xlsx/file-saver
// dependencies (already used for Contacts/Broadcasts import) instead of
// hand-rolled CSV escaping -- XLSX.utils.sheet_to_csv handles quoting,
// commas, embedded newlines, etc. correctly on its own.

// CSV/Formula-injection guard (OWASP-documented risk, not theoretical): a
// cell value starting with =, +, -, or @ can be parsed as a formula by
// Excel/Sheets on open. Every cell here ultimately traces back to
// account-controlled data (team member names, etc.), so it's sanitized
// before it reaches the sheet -- prefixing with a single quote is the
// standard mitigation (forces text, doesn't change the visible value in
// any spreadsheet app that matters).
const sanitizeCsvCell = (value) => {
  if (typeof value !== "string") return value;
  return /^[=+\-@]/.test(value) ? `'${value}` : value;
};

// headers: string[]; rows: array of arrays (same order as headers).
export const downloadCsv = (filename, headers, rows) => {
  const sanitizedHeaders = headers.map(sanitizeCsvCell);
  const sanitizedRows = rows.map((row) => row.map(sanitizeCsvCell));
  const worksheet = XLSX.utils.aoa_to_sheet([sanitizedHeaders, ...sanitizedRows]);
  const csv = XLSX.utils.sheet_to_csv(worksheet);
  // Leading BOM -- sheet_to_csv doesn't add one on its own, and without it
  // Excel on Windows (still the most common way these get opened) guesses
  // the wrong encoding for any non-ASCII name, mangling it on open.
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, filename);
};
